validate-phone-state {
  display: flex;
  min-height: 0;
  height: 100%;
}
